var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirm-title":"auth.confirm","deletingItems":_vm.orderId,"description":"account.are_you_sure_you_want_to_delete_this_order"},on:{"confirm":function($event){return _vm.$emit('confirmDelete')},"cancel":function($event){return _vm.$emit('closeModal')}}},[_c('icon-cancel-order',{attrs:{"size":80}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }